module.exports = __webpack_public_path__ + "706282864c8d98ca691bf8120c25398e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NR.svg
// module id = ZexQ
// module chunks = 0